<template>
  <div class="form-group">
    <div class="grey mb15">{{ label ?? name }}</div>
    <div class="row">
      <div :class="colClass" v-for="(option, index) in options" :key="index">
        <div class="form-check">
          <input class="form-check-input" :name="name" type="radio" :id="option.value" :value="option.value"
            v-model="inputValue" :disabled="disabled" v-validate="rules"/>
          <label class="form-check-label" :for="option.value">
            {{ option?.text }}
          </label>
        </div>
      </div>
      <small class="text-danger text-sm" v-show="errors.has(name)">
        {{ errors.first(name) }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldRadio',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    colClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    }
  },
  inject: ['$validator']
};
</script>
